import React, { useState } from 'react';
// Updated import to include Alert
import { Table, Tag, Space, Button, Card, Row, Col, Form, Input, Select, DatePicker, Typography, Cascader, Modal, Radio, message, Drawer, InputNumber, Switch, Tooltip } from 'antd';
import { SearchOutlined, ReloadOutlined, CheckCircleOutlined, CloseCircleOutlined, DollarOutlined, QuestionCircleOutlined, InfoCircleOutlined, ExperimentOutlined, RocketOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
const { Title, Text } = Typography;

const { Option } = Select;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

// 模拟语音助手列表
const voiceAssistantList = [
    { label: 'Amazon Alexa', value: 'alexa' },
    { label: 'Google Home', value: 'google' },
];

// 统一的类目数据
const categoryCascaderOptions = [
    {
        label: '摄像机',
        value: '1',
        children: [
            {
                label: '室内摄像机',
                value: '1-1',
                children: [
                    { label: '卡片机 (Wi-Fi)', value: '111' },
                    { label: '云台摄像机 (Wi-Fi)', value: '112' },
                    { label: '电池摄像机 (Wi-Fi)', value: '113' },
                ]
            },
            {
                label: '户外摄像机',
                value: '1-2',
                children: [
                    { label: '长电枪机 (Wi-Fi)', value: '121' },
                    { label: '长电球机 (Wi-Fi)', value: '122' },
                    { label: '电池枪机 (Wi-Fi)', value: '123' },
                    { label: '电池球机 (Wi-Fi)', value: '124' },
                    { label: '电池AOV摄像机 (Wi-Fi)', value: '125' },
                ]
            }
        ]
    },
    {
        label: '网关类',
        value: '2',
        children: [
            { label: 'HUB', value: '21' },
        ]
    }
];

const ProductAudit = () => {
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const [auditVisible, setAuditVisible] = useState(false);
    const [currentProduct, setCurrentProduct] = useState(null);
    const [auditForm] = Form.useForm();
    const [auditResult, setAuditResult] = useState('pass');

    // 自动赠送授权相关状态
    const [giftEnabled, setGiftEnabled] = useState(false);
    const [giftModalVisible, setGiftModalVisible] = useState(false);
    const [giftConfig, setGiftConfig] = useState({ testQuota: 5, productionQuota: 0 });
    const [giftForm] = Form.useForm();

    const handleGiftSwitch = (checked) => {
        if (checked) {
            giftForm.setFieldsValue(giftConfig);
            setGiftModalVisible(true);
        } else {
            setGiftEnabled(false);
            message.info('自动赠送授权已关闭');
        }
    };

    const handleGiftSave = async () => {
        try {
            const values = await giftForm.validateFields();
            setGiftConfig(values);
            setGiftEnabled(true);
            setGiftModalVisible(false);
            message.success('赠送配置已保存');
        } catch (e) {}
    };

    const handleGiftCancel = () => {
        setGiftModalVisible(false);
        setGiftEnabled(false);
    };

    // 赠送授权相关状态
    const [giftDrawerVisible, setGiftDrawerVisible] = useState(false);
    const [giftRecordModalVisible, setGiftRecordModalVisible] = useState(false);
    const [currentGiftProduct, setCurrentGiftProduct] = useState(null);
    const [giftRecordForm] = Form.useForm();

    const handleGiftRecord = (record) => {
        setCurrentGiftProduct(record);
        setGiftDrawerVisible(true);
    };

    const handleGiftRecordOpen = () => {
        giftRecordForm.resetFields();
        setGiftRecordModalVisible(true);
    };

    const handleGiftRecordSubmit = async () => {
        try {
            const values = await giftRecordForm.validateFields();
            message.success(`已赠送 ${values.quantity} 个授权`);
            setGiftRecordModalVisible(false);
            giftRecordForm.resetFields();
        } catch (e) {}
    };

    // 赠送记录假数据
    const giftRecords = [
        { id: '1', time: '2026-03-24 10:30:00', quantity: 5, account: '-', reason: '系统自动赠送策略触发', auth_type: 'test' },
        { id: '2', time: '2026-03-23 14:15:00', quantity: 10, account: 'admin', reason: '新产品上线赠送', auth_type: 'production' },
        { id: '3', time: '2026-03-22 09:45:00', quantity: 3, account: 'songdaozong', reason: '企业测试需求', auth_type: 'test' },
        { id: '4', time: '2026-03-21 16:20:00', quantity: 8, account: 'admin', reason: '促销活动赠送', auth_type: 'production' },
    ];

    const handleAudit = (record) => {
        setCurrentProduct(record);
        setAuditVisible(true);
        setAuditResult('pass');
        auditForm.setFieldsValue({ result: 'pass' });
    };

    const handleAuditSubmit = () => {
        auditForm.validateFields().then(values => {
            console.log('Audit values:', values);
            message.success(`产品 ${currentProduct.productName} 审核已提交：${values.result === 'pass' ? '通过' : '拒绝'}`);
            setAuditVisible(false);
            auditForm.resetFields();
        });
    };

    const mockData = [
        {
            key: '1',
            index: 1,
            productName: '智能室内卡片机',
            productId: 'P2MYHLjna9',
            category: '摄像机',
            status: '待审核',
            price: '1.00',
            testQuota: 10,
            productionQuota: 5,
            freeQuota: 5,
            producedNum: 47,            operator: 'heying2025',
            createTime: '2026-03-01',
            enterpriseName: '瀚晖通讯'
        },
        {
            key: '2',
            index: 2,
            productName: '户外电池枪机',
            productId: 'Pm38jEddh2',
            category: '摄像机',
            status: '开发中',
            price: '0.00',
            freeQuota: 0,
            producedNum: 0,
            operator: 'admin',
            createTime: '2026-02-28',
            enterpriseName: '瀚晖通讯'
        },
        {
            key: '3',
            index: 3,
            productName: '驳回测试产品',
            productId: 'PHWEu9JFZd',
            category: '网关类',
            status: '驳回开发中',
            price: '1.00',
            freeQuota: 5,
            producedNum: 0,
            operator: 'admin',
            createTime: '2026-02-28',
            enterpriseName: '瀚晖通讯'
        },
        {
            key: '4',
            index: 4,
            productName: '长电球机 (已发布)',
            productId: 'PaV98kLpQ2',
            category: '摄像机',
            status: '已发布',
            price: '2.50',
            freeQuota: 10,
            producedNum: 156,
            operator: 'admin',
            createTime: '2026-01-15',
            enterpriseName: '瀚晖通讯'
        },
        {
            key: '5',
            index: 5,
            productName: '智能云台摄像机-高配版',
            productId: 'P_DRV_001',
            category: '摄像机',
            status: '待审核',
            price: '1.00',
            freeQuota: 0,
            producedNum: 0,
            operator: 'admin',
            createTime: '2026-04-21',
            enterpriseName: '东莞康林物联网有限公司',
            source: 'ecosystem',
            vendorName: '深圳芯视界科技有限公司',
            vendorProductName: '智能云台摄像机方案',
            vendorProductId: 'P_ECO_001'
        },
    ];

    const columns = [
        { title: '序号', dataIndex: 'index', key: 'index', width: '5%', align: 'center' },
        { 
            title: '产品信息', 
            key: 'productInfo', 
            width: '10%',
            render: (_, record) => (
                <div>
                    <div style={{ fontWeight: 500 }}>{record.productName}</div>
                    <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{record.productId}</div>
                </div>
            )
        },
        { title: '产品类目', dataIndex: 'category', key: 'category', width: '10%' },
        { title: '产品类型', key: 'productType', width: '8%', render: () => <Tag color="blue">整机产品</Tag> },
        {
            title: '开发方式', key: 'source', width: '12%',
            render: (_, record) => {
                if (record.source === 'ecosystem') {
                    return (
                        <div>
                            <Tag color="blue">方案派生</Tag>
                            <div style={{ fontSize: 12, fontWeight: 500 }}>{record.vendorProductName || '—'}</div>
                            <div style={{ fontSize: 12, color: '#8c8c8c' }}>{record.vendorProductId || '—'}</div>
                        </div>
                    );
                }
                return <Tag color="green">自研开发</Tag>;
            },
        },
        { 
            title: '产品状态', 
            dataIndex: 'status', 
            key: 'status', 
            width: '8%',
            render: (status) => {
                let color = 'default';
                switch(status) {
                    case '待审核': color = 'blue'; break;
                    case '开发中': color = 'orange'; break;
                    case '驳回开发中': color = 'red'; break;
                    case '已发布': color = 'green'; break;
                    default: color = 'default'; break;
                }
                return <Tag color={color}>{status}</Tag>
            }
        },
        { title: '授权单价', dataIndex: 'price', key: 'price', width: '6%' },
        { 
            title: '赠送授权', 
            dataIndex: 'freeQuota', 
            key: 'freeQuota', 
            width: 110,
            render: (_, record) => (
                <div style={{ fontSize: '12px', whiteSpace: 'nowrap' }}>
                    <div>测试授权：{record.testQuota || 0}个</div>
                    <div>生产授权：{record.productionQuota || record.freeQuota || 0}个</div>
                </div>
            )
        },
        { title: '采购生产授权', dataIndex: 'producedNum', key: 'producedNum', width: '8%' },
        { 
            title: '所属企业', 
            dataIndex: 'enterpriseName', 
            key: 'enterpriseName', 
            width: '10%',
            render: (text, record) => (
                <div>
                    <div>{text}</div>
                    <div style={{ fontSize: '12px', color: '#8c8c8c' }}>{record.enterpriseId || 'ID:E7728392'}</div>
                </div>
            )
        },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime', width: '10%' },
        {
            title: '操作',
            key: 'action',
            fixed: 'right',
            width: '18%',
            render: (_, record) => (
                <Space size="middle">
                    {record.status === '待审核' && (
                        <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px' }} onClick={() => handleAudit(record)}>审核</Button>
                    )}
                    <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', color: '#1890ff' }} onClick={() => handleGiftRecord(record)}>赠送授权</Button>
                    <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', color: '#1890ff' }} onClick={() => navigate('/product/audit/manage', { state: record })}>管理产品</Button>
                    {record.source !== 'transferred' && (
                        <Button type="link" style={{ padding: 0, height: 'auto', fontSize: '12px', color: '#ff4d4f' }} onClick={() => {
                            Modal.confirm({
                                title: '确认删除',
                                content: `确认要删除产品 "${record.productName}" 吗？此操作不可撤销。`,
                                okText: '确认',
                                cancelText: '取消',
                                okType: 'danger',
                                onOk() {
                                    message.success('删除成功');
                                }
                            });
                        }}>删除产品</Button>
                    )}
                </Space>
            )
        }
    ];

    const onReset = () => {
        form.resetFields();
    };

    return (
        <div style={{ padding: '24px' }}>
      <div style={{ marginBottom: 16 }}>
        <Title level={4}>产品审核</Title>
      </div>
            <Card bordered={false} style={{ marginBottom: 16 }}>
                <Form form={form} layout="horizontal">
                    <Row gutter={[24, 16]}>
                        <Col span={8}>
                            <Input.Group compact style={{ display: 'flex' }}>
                                <Form.Item name="productKey" noStyle initialValue="productName">
                                    <Select style={{ width: '120px' }} onChange={() => form.setFieldsValue({ productValue: undefined })}>
                                        <Option value="productName">产品名称</Option>
                                        <Option value="productId">产品ID</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item shouldUpdate={(p, c) => p.productKey !== c.productKey} noStyle>
                                    {({ getFieldValue }) => {
                                        const key = getFieldValue('productKey') || 'productName';
                                        return key === 'productName' ? (
                                            <Form.Item name="productValue" noStyle>
                                                <Select 
                                                    showSearch 
                                                    placeholder="请选择产品名称" 
                                                    style={{ flex: 1 }} 
                                                    allowClear
                                                    optionFilterProp="label"
                                                    options={Array.from(new Set(mockData.map(i => i.productName))).map(v => ({ label: v, value: v }))}
                                                />
                                            </Form.Item>
                                        ) : (
                                            <Form.Item name="productValue" noStyle>
                                                <Input style={{ flex: 1 }} placeholder="请输入产品ID" allowClear />
                                            </Form.Item>
                                        );
                                    }}
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={8}>
                            <Form.Item name="status" label="产品状态">
                                <Select placeholder="请选择" allowClear style={{ width: '100%' }}>
                                    <Option value="developing">开发中</Option>
                                    <Option value="rejected">驳回开发中</Option>
                                    <Option value="pending">待审核</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name="category" label="产品类目">
                                <Cascader options={categoryCascaderOptions} placeholder="请选择产品类目" changeOnSelect style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Input.Group compact style={{ display: 'flex' }}>
                                <Form.Item name="enterpriseKey" noStyle initialValue="enterpriseName">
                                    <Select style={{ width: '120px' }} onChange={() => form.setFieldsValue({ enterpriseValue: undefined })}>
                                        <Option value="enterpriseName">所属企业</Option>
                                        <Option value="enterpriseId">企业ID</Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item shouldUpdate={(p, c) => p.enterpriseKey !== c.enterpriseKey} noStyle>
                                    {({ getFieldValue }) => {
                                        const key = getFieldValue('enterpriseKey') || 'enterpriseName';
                                        return key === 'enterpriseName' ? (
                                            <Form.Item name="enterpriseValue" noStyle>
                                                <Select 
                                                    showSearch 
                                                    placeholder="请选择所属企业" 
                                                    style={{ flex: 1 }} 
                                                    allowClear
                                                    optionFilterProp="label"
                                                    options={Array.from(new Set(mockData.map(i => i.enterpriseName))).map(v => ({ label: v, value: v }))}
                                                />
                                            </Form.Item>
                                        ) : (
                                            <Form.Item name="enterpriseValue" noStyle>
                                                <Input style={{ flex: 1 }} placeholder="请输入企业ID" allowClear />
                                            </Form.Item>
                                        );
                                    }}
                                </Form.Item>
                            </Input.Group>
                        </Col>
                        <Col span={8}>
                            <Form.Item name="createTime" label="创建时间">
                                <RangePicker style={{ width: '100%' }} placeholder={['开始时间', '结束时间']} />
                            </Form.Item>
                        </Col>
                        <Col span={8} style={{ textAlign: 'right' }}>
                            <Space>
                                <Button type="primary" icon={<SearchOutlined />}>查询</Button>
                                <Button icon={<ReloadOutlined />} onClick={onReset}>重置</Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
            </Card>

            <div style={{ marginBottom: 16, padding: '12px 16px', background: '#fafafa', borderRadius: 4, border: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 12 }}>
                <Space size={8}>
                    <Text style={{ fontSize: 13, color: 'rgba(0,0,0,0.65)' }}>自动赠送授权</Text>
                    <Tooltip title="产品创建完成后，自动为每个产品赠送指定数量的免费授权，以便于企业测试生产、测试固件">
                        <QuestionCircleOutlined style={{ color: 'rgba(0,0,0,0.45)', cursor: 'help', fontSize: 12 }} />
                    </Tooltip>
                    <Switch size="small" checked={giftEnabled} onChange={handleGiftSwitch} />
                    {giftEnabled && (
                        <Text type="secondary" style={{ fontSize: 12 }}>
                            每个产品自动赠送：测试授权 <Text strong style={{ color: 'rgba(0, 0, 0, 0.85)' }}>{giftConfig.testQuota} 个</Text>，生产授权 <Text strong style={{ color: 'rgba(0, 0, 0, 0.85)' }}>{giftConfig.productionQuota} 个</Text>
                        </Text>
                    )}
                </Space>
            </div>

            <Card bordered={false}>
                <Table 
                    columns={columns} 
                    dataSource={mockData} 
                    scroll={{ x: 1300 }}
                    pagination={{ showTotal: (total) => `共 ${total} 条记录` }}
                />
            </Card>

            <Drawer
                title="产品开发审核"
                width="45%"
                open={auditVisible}
                onClose={() => {
                    setAuditVisible(false);
                    auditForm.resetFields();
                }}
                footer={
                    <div style={{ textAlign: 'right', padding: '10px 16px' }}>
                        <Button onClick={() => setAuditVisible(false)} style={{ marginRight: 8 }}>取消</Button>
                        <Button type="primary" onClick={handleAuditSubmit}>确认审核</Button>
                    </div>
                }
                destroyOnClose
            >
                <Form
                    form={auditForm}
                    layout="vertical"
                    initialValues={{ 
                        result: 'pass', 
                        price: currentProduct?.price || '1.00',
                        free_assistants: voiceAssistantList.map(v => ({ type: v.value, label: v.label, enabled: false, storage: 'local', stream: 'main' }))
                    }}
                >
                    <div style={{ marginBottom: 24, background: '#f5f5f5', padding: '16px', borderRadius: '8px' }}>
                        <Row gutter={16}>
                            <Col span={12}>
                                <div style={{ fontSize: '12px', color: '#888', marginBottom: 4 }}>当前审核产品</div>
                                <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{currentProduct?.productName}</div>
                                <div style={{ fontSize: '13px', color: '#888' }}>{currentProduct?.productId}</div>
                            </Col>
                            <Col span={12}>
                                <div style={{ fontSize: '12px', color: '#888', marginBottom: 4 }}>所属企业</div>
                                <div style={{ fontSize: '15px', fontWeight: 'bold' }}>{currentProduct?.enterpriseName}</div>
                                <div style={{ fontSize: '13px', color: '#888' }}>{currentProduct?.enterpriseId || 'E7728392'}</div>
                            </Col>
                        </Row>
                    </div>
                    
                    <Form.Item
                        name="result"
                        label="审核结果"
                        rules={[{ required: true }]}
                    >
                        <Radio.Group onChange={(e) => setAuditResult(e.target.value)}>
                            <Radio.Button value="pass" style={{ color: '#52c41a' }}>
                                <CheckCircleOutlined /> 通过审核
                            </Radio.Button>
                            <Radio.Button value="reject" style={{ color: '#ff4d4f' }}>
                                <CloseCircleOutlined /> 驳回申请
                            </Radio.Button>
                        </Radio.Group>
                    </Form.Item>

                    {auditResult === 'pass' && (
                        <div style={{ padding: '4px 0', marginBottom: 20 }}>
                            <Form.Item
                                name="price"
                                label={
                                    <Space size={4}>
                                        <DollarOutlined style={{ color: '#1890ff' }} />
                                        <span style={{ fontWeight: 500 }}>授权单价</span>
                                    </Space>
                                }
                                rules={[{ required: true, message: '请输入授权单价' }]}
                                style={{ 
                                    marginBottom: 0, 
                                    padding: '12px 16px', 
                                    background: '#f0faff', 
                                    border: '1px solid #abdcff', 
                                    borderRadius: '4px' 
                                }}
                            >
                                <InputNumber 
                                    min={0} 
                                    placeholder="请输入单价" 
                                    style={{ width: '100%' }} 
                                    addonAfter="元" 
                                    precision={2}
                                />
                            </Form.Item>
                        </div>
                    )}

                    {auditResult === 'reject' && (
                        <Form.Item
                            name="reason"
                            label="驳回原因"
                            rules={[{ required: true, message: '请输入驳回说明' }]}
                        >
                            <TextArea rows={4} placeholder="请详细填写驳回申请的具体原因..." />
                        </Form.Item>
                    )}
                </Form>
            </Drawer>

            <Modal
                title="配置自动赠送授权"
                open={giftModalVisible}
                onOk={handleGiftSave}
                onCancel={handleGiftCancel}
                okText="保存"
                cancelText="取消"
                destroyOnClose
                width={480}
            >
                <div style={{ padding: '8px 0' }}>
                    <div style={{ background: '#e6f7ff', padding: '12px 16px', borderRadius: 8, border: '1px solid #91d5ff', marginBottom: 20 }}>
                        <Space align="start">
                            <InfoCircleOutlined style={{ color: '#1890ff', marginTop: 3 }} />
                            <Text style={{ fontSize: 13, color: 'rgba(0,0,0,0.65)' }}>产品创建完成后，系统将自动为该产品赠送指定数量的免费授权，以便于企业固件测试和工单生产。</Text>
                        </Space>
                    </div>
                    <Form form={giftForm} layout="vertical">
                        <Form.Item name="testQuota" label={<Text strong>每个产品赠送测试授权数量</Text>} rules={[{ required: true, message: '请输入测试授权赠送数量' }]} extra="测试授权用于固件测试">
                            <InputNumber style={{ width: '100%' }} min={1} precision={0} placeholder="请输入正整数" addonAfter="个" />
                        </Form.Item>
                        <Form.Item name="productionQuota" label={<Text strong>每个产品赠送生产授权数量</Text>} rules={[{ required: true, message: '请输入生产授权赠送数量' }]}  extra="生产授权用于创建工单">
                            <InputNumber style={{ width: '100%' }} min={0} precision={0} placeholder="请输入数量" addonAfter="个" />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>

            <Drawer
                title="赠送授权记录"
                width={850}
                onClose={() => setGiftDrawerVisible(false)}
                open={giftDrawerVisible}
                extra={
                    <Button type="primary" onClick={handleGiftRecordOpen}>赠送授权</Button>
                }
            >
                {currentGiftProduct && (
                    <div>
                        <div style={{ marginBottom: 24, padding: '12px 16px', background: '#f5f5f5', borderRadius: 4 }}>
                            <div style={{ marginBottom: 8 }}>
                                <Text type="secondary">产品名称：</Text>
                                <Text strong>{currentGiftProduct.productName}</Text>
                            </div>
                            <div>
                                <Text type="secondary">产品ID：</Text>
                                <Text strong>{currentGiftProduct.productId}</Text>
                            </div>
                        </div>
                        <Table
                            columns={[
                                { title: '赠送时间', dataIndex: 'time', key: 'time',width:'22%' },
                                {
                                    title: '类型',
                                    dataIndex: 'auth_type',
                                    key: 'auth_type',
                                    width: '12%',
                                    render: (type) => (
                                        <Tag color={type === 'test' ? 'cyan' : 'blue'}>
                                            {type === 'test' ? '测试授权' : '生产授权'}
                                        </Tag>
                                    )
                                },
                                {
                                    title: '赠送方式',
                                    key: 'giftType',
                                    width:'10%',
                                    render: (_, record) => (record.account === '-' ? '系统赠送' : '手动赠送')
                                },
                                { title: '赠送数量', dataIndex: 'quantity', key: 'quantity',width:'10%', render: (q) => `${q} 个` },
                                { title: '赠送账号', dataIndex: 'account', key: 'account',width:'12%',},
                                { title: '赠送原因', dataIndex: 'reason', key: 'reason', ellipsis: true }
                            ]}
                            dataSource={giftRecords}
                            rowKey="id"
                            size="small"
                            pagination={{
                                pageSize: 5,
                                showTotal: (total) => `共 ${total} 条记录`,
                                showSizeChanger: true,
                                showQuickJumper: true
                            }}
                        />
                    </div>
                )}
            </Drawer>

            <Modal
                title="赠送授权"
                open={giftRecordModalVisible}
                onOk={handleGiftRecordSubmit}
                onCancel={() => setGiftRecordModalVisible(false)}
                okText="确认赠送"
                cancelText="取消"
                destroyOnClose
                width={560}
            >
                {currentGiftProduct && (
                    <Form form={giftRecordForm} layout="vertical" initialValues={{ auth_type: 'test' }}>
                        <div style={{ marginBottom: 20, padding: '12px 16px', background: '#fafafa', borderRadius: 8, border: '1px solid #f0f0f0' }}>
                            <Row gutter={16}>
                                <Col span={12}>
                                    <Text type="secondary" style={{ fontSize: 12 }}>产品名称</Text>
                                    <div style={{ fontWeight: 500 }}>{currentGiftProduct.productName}</div>
                                </Col>
                                <Col span={12}>
                                    <Text type="secondary" style={{ fontSize: 12 }}>产品ID</Text>
                                    <div style={{ fontFamily: 'monospace' }}>{currentGiftProduct.productId}</div>
                                </Col>
                            </Row>
                        </div>

                        <Form.Item name="auth_type" label={<Text strong>授权类型</Text>} rules={[{ required: true }]}>
                            <Radio.Group style={{ width: '100%' }}>
                                <Row gutter={12}>
                                    <Col span={12}>
                                        <Radio.Button value="test" style={{ width: '100%', height: 'auto', padding: '12px', borderRadius: 8 }}>
                                            <Space direction="vertical" size={4} style={{ width: '100%' }}>
                                                <Space><ExperimentOutlined style={{ color: '#13c2c2' }} /><Text strong>测试授权</Text></Space>
                                                <Text type="secondary" style={{ fontSize: 12, display: 'block', whiteSpace: 'normal', lineHeight: '1.4' }}>
                                                    测试授权用于固件测试
                                                </Text>
                                            </Space>
                                        </Radio.Button>
                                    </Col>
                                    <Col span={12}>
                                        <Radio.Button value="production" style={{ width: '100%', height: 'auto', padding: '12px', borderRadius: 8 }}>
                                            <Space direction="vertical" size={4} style={{ width: '100%' }}>
                                                <Space><RocketOutlined style={{ color: '#1890ff' }} /><Text strong>生产授权</Text></Space>
                                                <Text type="secondary" style={{ fontSize: 12, display: 'block', whiteSpace: 'normal', lineHeight: '1.4' }}>
                                                    生产授权用于创建工单
                                                </Text>
                                            </Space>
                                        </Radio.Button>
                                    </Col>
                                </Row>
                            </Radio.Group>
                        </Form.Item>

                        <Row gutter={16}>
                            <Col span={24}>
                                <Form.Item name="quantity" label={<Text strong>赠送数量</Text>} rules={[{ required: true, message: '请输入赠送数量' }]}>
                                    <InputNumber style={{ width: '100%' }} min={1} precision={0} placeholder="请输入正整数" addonAfter="个" />
                                </Form.Item>
                            </Col>
                        </Row>
                        
                        <Form.Item name="reason" label={<Text strong>赠送原因</Text>} rules={[{ required: true, message: '请输入赠送原因' }]}>
                            <Input.TextArea placeholder="请输入赠送原因，例如：新产品测试赠送" rows={3} maxLength={100} showCount />
                        </Form.Item>

                     
                    </Form>
                )}
            </Modal>
        </div>
    );
};

export default ProductAudit;
